import { useContext } from 'react';
import { Moon, Sun } from 'lucide-react';
import { Button } from '@socio-legal/react-components';

import { useTranslate } from 'hooks/useTranslate';
import ThemeContext from 'modules/_shared/contexts/ThemeContext';

import './LoginThemeToggle.scss';

const LoginThemeToggle = () => {
  const { t } = useTranslate();
  const { darkTheme, toggleTheme } = useContext(ThemeContext);
  const Icon = darkTheme ? Sun : Moon;

  return (
    <div className="login-theme-toggle">
      <Button
        type="button"
        variant="link"
        className="login-theme-toggle__button text-soft"
        icon={Icon}
        aria-label={t(darkTheme ? 'LightMode' : 'DarkMode')}
        onClick={toggleTheme}
      />
    </div>
  );
};

export default LoginThemeToggle;
